import React from 'react';
import { VStack } from 'native-base';
import { Member, I18nReacher, useTheme } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

type ReferCopyLinkProps = {
    copyToClipboard: (link: string) => void;
    link: I18nReacher;
    member?: Member;
    isHideText?: boolean;
};

const ReferCopyLink = ({
    copyToClipboard,
    link,
    member,
    isHideText = false,
}: ReferCopyLinkProps) => {

    const {
        highlight_text,
    } = useTheme();

    return (
        <VStack w={'100%'} alignItems={'center'} space={2}>
            { !isHideText &&
                <Caption
                    text='refer.text_link'
                    textAlign={'center'}
                />
            }
            { !isHideText &&
                <Caption
                    fontWeight={'bold'}
                    color={highlight_text}
                    textAlign={'center'}
                >
                    { member && member.referrals?.link }
                </Caption>
            }
            <Button
                text={link}
                onPress={copyToClipboard}
            />
        </VStack>
    );
};

export default ReferCopyLink;
